// Group updates always use activity IDs; a task ID would update both groups.
export const submitStatusChange = async ({
  api,
  scope,
  selectedTask,
  selectedParcel,
  data,
  completedIds,
}) => {
  const targets =
    scope?.type === 'group'
      ? [...new Set(scope.activities.map((activity) => activity.id))].map(
          (activityId) => ({ activityId })
        )
      : [
          scope === 'task'
            ? { id: selectedTask?.id }
            : { activityId: selectedParcel?.id },
        ];

  if (
    !targets.length ||
    targets.some((target) => (target.activityId ?? target.id) == null)
  ) {
    throw new Error('مرسوله‌ای برای تغییر وضعیت انتخاب نشده است');
  }

  for (const target of targets) {
    const key = JSON.stringify(target);
    if (completedIds.has(key)) continue;
    await api.post('/api/app/v1/shipito/tasks/change-status', { ...data, ...target });
    completedIds.add(key);
  }
};
